import { ToggleButtonStyles, ToggleButtonTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { ToggleButton } from "./toggle-button.js";
/**
 * The Fabric Toggle Button component.
 *
 * @public
 */
export const definition = ToggleButton.compose({
    name: `${DesignSystem.prefix}-toggle-button`,
    template: ToggleButtonTemplate,
    styles: ToggleButtonStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=toggle-button.definition.js.map